import { useEffect } from "react";
import apiClient from "@/lib/api-client";
import { deriveSource, storeReferral } from "@/lib/referral";
import { analytics, ANALYTICS_EVENTS } from "@/lib/analytics";

/**
 * Captures inbound referral codes from `?s=<id>` on page load.
 * Stores attribution in a 30-day cookie, fires a click increment,
 * and strips the `s` param from the URL.
 *
 * Mount once in Layout.
 */
export function useReferralCapture(): void {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const shareId = params.get("s");
    if (!shareId || !/^[A-Za-z0-9_-]{1,21}$/.test(shareId)) return;

    const source = deriveSource();

    // Last-touch: overwrite any previous referral
    storeReferral(shareId, source);

    // Increment click counter (best-effort)
    void apiClient.post(`/shares/${shareId}/click`).catch(() => {});

    // Analytics
    analytics.track(ANALYTICS_EVENTS.REFERRAL_CAPTURED, { shareId, source });

    // Strip `s` from URL without triggering navigation
    params.delete("s");
    const newSearch = params.toString();
    const newUrl =
      window.location.pathname +
      (newSearch ? `?${newSearch}` : "") +
      window.location.hash;
    window.history.replaceState(null, "", newUrl);
  }, []);
}
